import { Alert, Skeleton, Timeline, TimelineItemProps } from "antd";
import moment from "moment";
import _ from "lodash";

import { useState } from "react";

import HrText from "components/HrText/HrText";
import { IPrenotazioneExt } from "core/interfaces/data/IAssistitoRequest";
import IPrenotazioniUtente from "pages/AreaRiservata/PrenotazioniUtente/IPrenotazioniUtente";
import "./PrenotazioniUtente.css";
import ReservationsTimeLine from "components/ReservationsTimeLineItems/ReservationsTimeLineItems";
import { Enhanced } from "utils/ReactUtils";
import { FaRegCalendarAlt, FaRegCircle, FaRegClock } from "react-icons/fa";
import { IDescrizioneAttivita } from "core/interfaces/data/IPrestazioneRequest";
import CustomShelf from "components/CustomShelf/CustomShelf";

const PrenotazioniUtente: React.FC<IPrenotazioniUtente> = ({ prenotazioni, descrizioni, t }) => {
	const [loading] = useState<boolean>(false);

	// useEffect(() => {
	// 	console.log("prenotazioni utente");
	// 	console.log(prenotazioni, descrizioni);
	// }, [prenotazioni, descrizioni]);

	const datePrenotazioniGet = () => {
		let prenotazioniExt: any = _.map(prenotazioni, (p: IPrenotazioneExt) => {
			let mom = moment(p.OccupazioneDa).startOf("day");
			p.GroupByDate = mom.toDate();
			p.GroupByString = mom.format("DD/MM/YYYY");
			return p;
		});

		prenotazioniExt = _.sortBy(prenotazioniExt, "OccupazioneDa").reverse();
		prenotazioniExt = _.sortBy(prenotazioniExt, "GroupByDate").reverse();
		let gropuedPrenotazioni = _.groupBy<[string, IPrenotazioneExt]>(prenotazioniExt, (p: IPrenotazioneExt) => {
			return p.GroupByString;
		});
		let res = Object.entries(gropuedPrenotazioni);
		return res;
	};

	const [descrizione, setDescrizione] = useState("");
	const [mostraDescrizione, setMostraDescrizione] = useState(false);

	const recuperaDescrizione = (igu: any) => {
		if (descrizioni !== undefined) {
			const descrizione = descrizioni.find((el: IDescrizioneAttivita) => {
				return el.IguAttivita === igu;
			});
			if (descrizione !== undefined && descrizione.DettagliAttivita !== undefined) {
				setDescrizione(descrizione.DettagliAttivita);
			} else {
				setDescrizione("");
			}
			setMostraDescrizione(true);
		}
	};
	const getItems = (): TimelineItemProps[] => {
		var res = datePrenotazioniGet().map((x, index) => {
			let date = x[0];
			let today = moment().startOf("day");
			let dateRifDay = moment(date, "DD/MM/YYYY").startOf("day");
			let dotType = today.isSame(dateRifDay) ? "present" : today.isSameOrAfter(dateRifDay) ? "past" : "future";

			var item: TimelineItemProps = {
				key: `${date.toString()}|${index}`,
				className: "reservations-timeline",
				dot:
					dotType === "future" ? (
						<FaRegClock className={`timeline-ico ${dotType}`}></FaRegClock>
					) : dotType === "past" ? (
						<FaRegCalendarAlt className={`timeline-ico ${dotType}`}></FaRegCalendarAlt>
					) : (
						<FaRegCircle className={`timeline-ico ${dotType}`}></FaRegCircle>
					),
				children: <ReservationsTimeLine item={x as [string, Array<IPrenotazioneExt>]} onInfoClick={recuperaDescrizione} descrizioni={descrizioni}></ReservationsTimeLine>,
			};

			return item;
		});
		return res;
	};

	return (
		<>
			{loading ? (
				<Skeleton active />
			) : (
				<>
					<div id="prenotazioniUtente">
						{prenotazioni ? (
							<>
								<HrText text={t("Prenotazioni.title")} />

								{prenotazioni && prenotazioni.length > 0 ? (
									<Timeline className="timeline-padding" items={getItems()} />
								) : (
									<>
										<span className="text">{t("reservedArea.prenotazioniUtente.noReservationFound")}</span>
									</>
								)}
							</>
						) : (
							<Alert message={t("errorMessages.base")} type="error" showIcon banner />
						)}
					</div>
					<CustomShelf
						open={mostraDescrizione}
						onClose={() => {
							setMostraDescrizione(false);
						}}
					>
						{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
						<div className="shelf-descrizione-attivita" tabIndex={0}>
							<h2>{t("riepilogo.text.descrizione")}</h2>
							{descrizione ? (
								<p className="testo-descrizione-attivita" dangerouslySetInnerHTML={{ __html: descrizione }}></p>
							) : (
								<p>{t("riepilogo.text.descrizione-assente")}</p>
							)}
						</div>
					</CustomShelf>
				</>
			)}
		</>
	);
};

export default Enhanced(PrenotazioniUtente, { componentNamespace: "PrenotazioniUtente" });